(function(window, $) {
    /////// TEXT TOGGLER
    $(document).on('click', '[data-toggle-trigger]', function(){
        $(this).find('[data-toggle-label]').toggle();
    });
    /////// TEXT TOGGLER


    $(document).on('click', '.filter-wrapper .apply-and-close', function() {
        $('.filters-wrapper .filters-wrapper').trigger('click');
    });
})(window, jQuery);
